import React, { Component } from 'react'
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import './SelectLabel.scss'
import transverser from '../../../utils/transverser'
import classNames from 'classnames'
import _ from 'lodash'
import FintupIcon from '../FintupIcon'
/*
  Props:
    disabled: Deshabilita el elemento
    innerInput: Para mostrar el input en formato datos personales con el label incluido dentro del input
    innerLabelWidth: Genera la clase que dara el ancho al label
    theme: ('tools' || 'new') Para renderizar el select de una forma u otra concreta
      * 'tools' : Para renderizar como en la herrameinta un millon
      * 'new': Nuevo estilo de componentes similar al diseño minitest
*/
class SelectLabel extends Component {
  constructor(props) {
    super(props)

    let selectedLabel = ''
    let selectedValue = transverser.get('selectedValue', '')(this.props)
    if (selectedValue !== '' && this.props.options) {
      selectedLabel = _.find(this.translateOptions, function (option) {
        return option.value === selectedValue
      })
    }
    selectedLabel = selectedLabel || ''

    this.state = {
      props: props,
      value: transverser.get('selectedValue', '')(this.props),
      label: selectedLabel,
      searchable: _.isUndefined(this.props.searchable) ? true : this.props.searchable
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedValue !== nextProps.selectedValue) {
      this.setState({ value: nextProps.selectedValue })
    }
  }

  handleChange(data) {
    if (data) {
      let fieldValue = data.value
      let labelValue = data.label
      this.setState({ value: fieldValue, label: labelValue })
      if (this.props.callBackOnChange) {
        let data = {
          ev: {
            target: {
              name: this.props.name,
              value: fieldValue
            }
          },
          name: this.props.name,
          value: this.state.value,
          label: this.state.label
        }
        this.props.callBackOnChange(data)
      }
    }
  }

  get translateOptions() {
    let options = this.props.options || []
    return options.map(item => {
      return {
        label: item.labelText || this.props.intl.formatMessage({ id: item.label }),
        value: item.value
      }
    })
  }

  get inputSizeClasses() {
    let labelSize = this.props.horizontal ? parseInt(this.props.labelSize, 10) : 0
    let inputSize = 12 - labelSize
    return classNames(
      `col-sm-${inputSize}`,
      'newStyleGrid',
      { 'paddingRight15': this.props.horizontal }
    )
  }

  getLabelElement() {
    let labelText = this.props.label
      ? this.props.htmlLabel
        ? <FormattedHTMLMessage id={this.props.label} />
        : <FormattedMessage id={this.props.label} />
      : ''
    let labelElement = this.props.label ? <label className={this.labelElementClasses} htmlFor={this.props.name}>{labelText}</label> : ''
    return labelElement
  }

  getPlaceholder() {
    return this.props.placeholder ? this.props.intl.formatMessage({ id: this.props.placeholder }) : ''
  }

  getRequiredElement() {
    return this.props.required ? <span className="required-label">*</span> : ''
  }

  get arrowRenderFunction() {
    return this.props.innerInput || this.props.theme === 'tools' || this.props.theme === 'new'
      ? this.arrowRenderer
      : undefined
  }
  arrowRenderer() {
    return <FintupIcon size="10" icon="flecha-seleccionable-abajo" />
  }

  get errorContent() {
    return this.props.isError
      ? <span className="errorText">
        {this.props.errorText ? this.props.errorText : <FormattedMessage id={this.props.errorTextKey} />}
      </span>
      : ''
  }

  get getInputElement() {
    return (
      <div>
        <Select
          arrowRenderer={this.arrowRenderFunction}
          disabled={this.props.disabled}
          placeholder={this.getPlaceholder()}
          name={this.props.name}
          value={this.state.value}
          onChange={this.handleChange.bind(this)}
          options={this.translateOptions}
          clearable={false}
          searchable={this.state.searchable}
        />
        {this.errorContent}
      </div>

    )
  }

  verticalRender() {
    return (
      <div className="form-group">
        {this.getLabelElement()}
        {this.getRequiredElement()}
        {this.getInputElement}
      </div>
    )
  }

  get renderInnerInput() {
    return (
      <div className="form-group row">
        <div className={this.inputSizeClasses}>
          {this.getLabelElement()}
          {this.getInputElement}
        </div>
      </div>
    )
  }

  horizontarRightRender() {
    return (
      <div className="form-group row">
        <div className={this.inputSizeClasses}>
          {this.getInputElement}
        </div>
        {this.getLabelElement()}
      </div>
    )
  }

  horizontarRender() {
    return (
      <div className="form-group row">
        {this.getLabelElement()}
        <div className={this.inputSizeClasses}>
          {this.getInputElement}
        </div>
      </div>
    )
  }

  get labelElementClasses() {
    return classNames(
      this.props.horizontal ? `col-sm-${this.props.labelSize} col-form-label` : '',
      this.props.htmlLabel ? 'htmlLabel' : '',
      this.props.showDivider ? 'dividerLabel' : '',
      this.props.rightLabel ? 'rightLabel' : '',
      'labelInputContainer'
    )
  }

  get renderTemplate() {
    let horizontarlInput = this.props.horizontal
    return this.props.innerInput
      ? this.renderInnerInput
      : horizontarlInput
        ? this.props.rightLabel
          ? this.horizontarRightRender()
          : this.horizontarRender()
        : this.verticalRender()
  }

  get innerLabelWidthClass() {
    return `innerLabelWidth${this.props.innerLabelWidth}`
  }

  get componentClasses() {
    return classNames(
      'selectLabel',
      { [`theme-${this.props.theme}`]: this.props.theme },
      this.props.className,
      { 'innerInput': this.props.innerInput },
      this.innerLabelWidthClass,
      { 'is-error': this.props.isError }
    )
  }

  render() {
    return (
      <div className={this.componentClasses}>
        {this.renderTemplate}
      </div>
    )
  }
}

export default injectIntl(SelectLabel)
